import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" >")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Message = _resolveComponent("Message")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_SchedulerDocumentsSelectionDialog = _resolveComponent("SchedulerDocumentsSelectionDialog")
  const _component_SchedulerDocumentParameterDialog = _resolveComponent("SchedulerDocumentParameterDialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('common.documents')), 1)
      ]),
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "kn-button p-button-text p-button-rounded",
          onClick: _ctx.openDocumentsSelectionDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.add')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }),
    (_ctx.documents?.length === 0)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          class: "p-m-4",
          severity: "info",
          closable: false,
          style: _ctx.schedulerDocumentsTableDescriptor.styles.message
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.scheduler.noDocumentsInfo')), 1)
          ]),
          _: 1
        }, 8, ["style"]))
      : (_openBlock(), _createBlock(_component_DataTable, {
          key: 1,
          id: "documents-datatable",
          value: _ctx.documents,
          paginator: true,
          rows: _ctx.schedulerDocumentsTableDescriptor.rows,
          class: "p-datatable-sm kn-table p-m-2",
          dataKey: "name",
          responsiveLayout: _ctx.schedulerDocumentsTableDescriptor.responsiveLayout,
          breakpoint: _ctx.schedulerDocumentsTableDescriptor.breakpoint,
          "data-test": "documents-table"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              class: "kn-truncated",
              header: _ctx.$t('common.name'),
              style: _ctx.schedulerDocumentsTableDescriptor.nameColumnStyle
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.name), 1)
              ]),
              _: 1
            }, 8, ["header", "style"]),
            _createVNode(_component_Column, {
              header: _ctx.$t('common.parameters')
            }, {
              body: _withCtx((slotProps) => [
                (_ctx.checkIfParameterValuesSet(slotProps.data.parameters))
                  ? (_openBlock(), _createBlock("span", _hoisted_1, _toDisplayString(slotProps.data.condensedParameters), 1))
                  : _withDirectives((_openBlock(), _createBlock("span", _hoisted_2, [
                      _createVNode("i", {
                        class: "pi pi-exclamation-triangle kn-warning-icon",
                        "data-test": 'warning-icon-' + slotProps.data.name
                      }, null, 8, ["data-test"])
                    ], 512)), [
                      [
                        _directive_tooltip,
                        _ctx.$t('managers.scheduler.parametersWarningTooltip'),
                        void 0,
                        { top: true }
                      ]
                    ]),
                (slotProps.data.parameters?.length > 0)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 2,
                      icon: "pi pi-pencil",
                      class: "p-button-link",
                      onClick: ($event: any) => (_ctx.openDocumentParameterDialog(slotProps.data))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              style: _ctx.schedulerDocumentsTableDescriptor.iconColumnStyle
            }, {
              body: _withCtx((slotProps) => [
                _createVNode(_component_Button, {
                  icon: "pi pi-trash",
                  class: "p-button-link",
                  onClick: ($event: any) => (_ctx.removeDocumentConfirm(slotProps.index))
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        }, 8, ["value", "rows", "responsiveLayout", "breakpoint"])),
    _createVNode(_component_SchedulerDocumentsSelectionDialog, {
      visible: _ctx.documentsSelectionDialogVisible,
      propFiles: _ctx.files,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.documentsSelectionDialogVisible = false)),
      onDocumentSelected: _ctx.onDocumentSelected
    }, null, 8, ["visible", "propFiles", "onDocumentSelected"]),
    _createVNode(_component_SchedulerDocumentParameterDialog, {
      visible: _ctx.documentParameterDialogVisible,
      propParameters: _ctx.selectedDocument?.parameters,
      roles: _ctx.roles,
      deletedParams: _ctx.deletedParams,
      onClose: _ctx.closeDocumentParameterDialog,
      onSetParameters: _ctx.onParametersSet,
      documentLabel: _ctx.documentLabel
    }, null, 8, ["visible", "propParameters", "roles", "deletedParams", "onClose", "onSetParameters", "documentLabel"])
  ]))
}